import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import IMG from "../../../constants/image";
import {cleanNumber} from "../../../utils";
import {clsx} from "clsx";
import ImageBasic from "../Image/ImageBasic";


const Input = ({
                   id,
                   dot,
                   type,
                   name,
                   warningIcon,
                   viewOnly,
                   error,
                   title,
                   autoComplete,
                   inputMode,
                   className,
                   icon,
                   iconR,
                   placeholder,
                   value,
                   onChange,
                   required,
                   readOnly,
                   setError,
                   helper,
                   classNameInput,
                   errorCustom
               }) => {

    const [iconRight, setIconRight] = useState(iconR);
    const inputRef = useRef(null);


    useEffect(() => {
        setIconRight(iconR)
    }, [iconR])

    // Handle input change
    const handleChange = (e) => {
        onChange(e);
        if (dot) {
            const inputValue = e.target.value;
            // Remove any non-numeric characters (except for dots that were already formatted)
            // Format the numeric value with dots
            const formattedValue = cleanNumber(inputValue);
            // Update the state with the formatted value
            onChange({target: {name, value: formattedValue}});
        } else {
            onChange(e);
        }
    };

    const handleClickRightIcon = () => {
        if (type === 'password') {
            if (inputRef.current.type === 'password') {
                inputRef.current.type = 'text';
                setIconRight(IMG.icon.eyeBlackOpen);
            } else if (inputRef.current.type === 'text') {
                inputRef.current.type = 'password';
                setIconRight(IMG.icon.eyeBlack);
            }
        }
    }
    const handleFocus = () => {
        if (error && typeof setError === 'function')
            setError('')
    }

    const handleKeyDown = (e) => {
        // Prevent the default behavior for "e", "E", "+", and "-" keys
        if (type === 'number') {
            if (e.key === 'e' || e.key === 'E') {
                e.preventDefault();
            }
        }
    };

    if (viewOnly) {
        return (
            <div className='text-sm w-full'>
                {title && <p className='mb-1'>{title}</p>}
                <p className='text-[#9E9E9E] py-2'>{value}</p>
            </div>
        );
    }

    return (
        <div id={id} className='relative text-sm w-full'>
            {errorCustom && <div className='absolute flex space-x-1 top-2 right-3 text-[#E4626F] text-xs'>
                <ImageBasic src={IMG.icon.errorOutline} alt={'warning'} className='w-4 h-4'/>
                <div>{errorCustom}</div>
            </div>
            }
            {title &&
                <p className='text-sm mb-1 flex items-center gap-1 pt-2'>
                    {title}
                    {helper && <span className='text-gray-400'>{helper}</span>}
                    {required && <span className='text-[#E4626F]'>*</span>}
                    {warningIcon && <img className='w-4 h-4' src={warningIcon} alt="warning"/>}
                </p>
            }
            <div
                className={cn('relative flex justify-between items-center p-2 border border-[#D9D9D9] rounded-lg gap-1', className, error && 'border-red-500 text-[#E4626F]')}>
                {icon && <img className='w-5 h-5' src={icon} alt="icon"/>}
                <input
                    ref={inputRef}
                    className={clsx(classNameInput, 'w-full')}
                    type={type || "text"}
                    name={name}
                    autoComplete={autoComplete || ''}
                    inputMode={inputMode}
                    placeholder={placeholder}
                    value={value}
                    readOnly={readOnly}
                    onFocus={handleFocus}
                    onKeyDown={handleKeyDown}
                    onChange={handleChange}/>
                {iconR && <img className='w-4 h-4 cursor-pointer' src={iconRight} alt="iconR"
                               onClick={handleClickRightIcon}/>}
                {error && (
                    <div className='absolute bottom-[-22px] left-0 flex items-center gap-1'>
                        <img src={IMG.icon.errorOutline} alt="errorOutline"/>
                        <p className='text-[#E4626F] text-xs'>{error}</p>
                    </div>
                )}
            </div>
        </div>

    )
}

export default Input
